import axios from "axios";
import {useState} from "react"
import QRCode from "qrcode";
import { config, isDevMode } from "../utils/Constants";
import { useDispatch } from "react-redux";
import useErrorHandler from "../components/ErrorHandler";
import { useNavigate } from "react-router-dom";
import useGenerateToken from "../authentication/GenerateToken";
import { fetchRolesAndPermissions } from "../features/roleAndPermissionsSlice";
import useDeliveryPickupAxios from "../utils/axios";
import { setwebSocketResponse } from "../features/webSocketSlice";
import CryptoJS from "crypto-js";


const useLoginApi = () => {
    const {ErrorHandler} = useErrorHandler();
    const URL = config.url;
    const URLWEBSOCKET = config.urlWebSocket
    const [isLoading, setIsLoading] = useState(true);
    const { generateToken } = useGenerateToken();
    const navigate = useNavigate();

    const dispatch = useDispatch();

    const DeliveryPickupAxios = useDeliveryPickupAxios();

    const PortalOnBoard = async (setQrTimeOut, setQrUrl) => {    
            try{
                setQrTimeOut(false);
                setIsLoading(true);
                const url = URL + "/Authentication/OnBoard";
                const res = await axios.get(url, {Code: ""})

                sessionStorage.setItem("SessionID", res.data.payload.sessionID);

                const qr = await QRCode.toDataURL(res.data.payload.qr);
                setIsLoading(false);
                setQrUrl(qr);
            } catch(error){
  
                setIsLoading(false);
                setQrTimeOut(true);
            }
    }

    const checkQrAxios = async () => {
        try {
            const body = {
                "SessionID": sessionStorage.getItem("SessionID")
            };
            const res = await axios.post(`${URL}/Authentication/CheckQrStatus`, body, {
                headers: {
                    "Content-Type": "application/json",
                },
            });

            const result = res.data.payload;
            if (result) {
                sessionStorage.setItem("Features", JSON.stringify(result.sections));
                sessionStorage.setItem("UserName", result.employeeName);
                sessionStorage.setItem("Role", result.role)
            }

            return res;
        } catch (error) {
            ErrorHandler(error);
            throw error;
        }
    };

    const CheckQrStatus = async (timerStatus, setQrTimeOut) => {
        try {
            const res = await checkQrAxios();
            const status = res.data.payload.sessionStatus;


            if (status.toUpperCase() === "SCANNED") {
                clearInterval(timerStatus);
                setIsLoading(true);
                try {
                    await generateToken(
                        sessionStorage.getItem("SessionID"),
                        timerStatus,
                        res.data
                    );
                } catch (e) {
                    setIsLoading(false);
                    setQrTimeOut(true);
                }
            }
            return {
                status: res.status,
                sessionStatus: status,
            };
        } catch (e) {
            setIsLoading(false);
            clearInterval(timerStatus);
            setQrTimeOut(true);
            throw e;
        }
    };

    

    const GenerateWebSocketToken = async () => {
        try {
            const response = await DeliveryPickupAxios.post(`/WebSocket/GenerateWebSocketToken`);
            dispatch(setwebSocketResponse(response.data.webSokcetToken));
        } catch (error) {
            console.error("Error generating WebSocket token:", error);
        }
    };
    

    return {
        isLoading,
        PortalOnBoard,
        CheckQrStatus,
        checkQrAxios,
        GenerateWebSocketToken
    }
}


export default useLoginApi;